import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { AdminRootState, AppDispatch } from './AdminStore'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<AdminRootState> = useSelector